import React from 'react';
import { motion } from 'framer-motion';

const events = [
  {
    title: "Festivals & Concerts",
    tagline: "Capture the Vibe",
    desc: "From front row to the nosebleeds, collect every core memory without the social media compression.",
    img: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&q=80&w=800",
    color: "from-blue-600"
  },
  {
    title: "Luxury Weddings",
    tagline: "The Unseen Moments",
    desc: "The candid laughs, the late-night dance floor, and the details your photographer missed.",
    img: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&q=80&w=800",
    color: "from-purple-600"
  },
  {
    title: "Tech Summits",
    tagline: "Network & Share",
    desc: "Instant photo sharing for keynotes and networking mixers. Professional, fast, and secure.",
    img: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&q=80&w=800",
    color: "from-indigo-600"
  },
  {
    title: "Intimate Parties",
    tagline: "Pure Memories",
    desc: "Birthdays and reunions where the best camera is the one in your guest's hand.",
    img: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&q=80&w=800",
    color: "from-pink-600"
  }
];

export default function EventsShowcase() {
  return (
    <section id="events" className="py-32 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
          <div className="max-w-2xl">
            <h2 className="text-sm font-black text-indigo-500 uppercase tracking-[0.4em] mb-4">Event Ecosystem</h2>
            <h3 className="text-5xl md:text-7xl font-black tracking-tighter leading-none">Built for the <br /><span className="text-zinc-700 italic">Grand & Intimate.</span></h3>
          </div>
          <p className="text-slate-500 text-lg md:text-xl font-light max-w-sm">
            Kuhako scales with your energy, providing a premium vault for memories of any size.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {events.map((event, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group relative h-[550px] rounded-[2.5rem] overflow-hidden border border-white/5 cursor-pointer shadow-2xl"
            >
              <img src={event.img} alt={event.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
              <div className={`absolute inset-0 bg-gradient-to-t ${event.color} via-black/20 to-transparent opacity-40 group-hover:opacity-60 transition-opacity`} />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              
              <div className="absolute bottom-0 left-0 right-0 p-10 transform translate-y-6 group-hover:translate-y-0 transition-transform duration-500">
                <span className="text-xs font-black uppercase tracking-widest text-white/60 mb-2 block">{event.tagline}</span>
                <h4 className="text-3xl font-black text-white mb-4">{event.title}</h4>
                <p className="text-slate-300 text-sm leading-relaxed font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                  {event.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}